import React from 'react';
import Layout from './Layout';
import { FileUploaderWidgetLayoutProps } from './types';

export function FileUploaderWidget(
  props: FileUploaderWidgetLayoutProps
) {
  return (
    <Layout {...props} />
  );
}
